import { Loader } from 'lucide-react';

import { cn } from '../../../shadcn/lib/utils';

interface LoadingSpinnerProps {
  readonly className?: string;
}

export function LoadingSpinner({ className }: LoadingSpinnerProps) {
  return (
    <div
      className={cn('w-full flex items-center justify-center min-h-screen bg-[var(--color-neutral-100)]', className)}
    >
      <Loader className={'w-12 h-12 animate-spin text-[var(--color-primary-500)]'} />
    </div>
  );
}
